import React, { useState, useRef, useEffect } from 'react';
// import axios from 'axios';
import { useOutsideAlerter } from './SelectField';
import ChevronUpDownIcon from '../icons/ChevronUpDownIcon';
import CloseIcon from '../icons/CloseIcon';

const TagCloud = ({
  inputLabel,
  inputPlaceholder = 'Type and press Enter...',
  tags,
  preselected = [],
  disabled,
  requiredField,
  hasError,
  helperText,
  // showCreate = false,
  // creating,
  createFunction,
  returnFieldValue,
  position = 'bottom'
}) => {
  const positionClasses = {
    bottom: 'top-[70px] left-0',
    top: 'bottom-[75px] left-0'
  }
  const [selectedTags, setSelectedTags] = useState(preselected);
  const [query, setQuery] = useState('');
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [filteredTags, setFilteredTags] = useState(tags);
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, () => setOptionsOpen(false));

  useEffect(() => {
    // Filter dropdown based on query
    if (query.trim().length > 0) {
      const filtered = tags.filter((t) =>
        t.label.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredTags(filtered);
    } else {
      setFilteredTags(tags);
    }
  }, [query, tags]);

  const addTag = (tag) => {
    if (!selectedTags.some((t) => t.value === tag.value)) {
      const newTags = [...selectedTags, tag];
      setSelectedTags(newTags);
      returnFieldValue?.(newTags);
    }
    setQuery('');
    setOptionsOpen(false);
  };

  const removeTag = (value) => {
    if(disabled) return
    const newTags = selectedTags.filter((t) => t.value !== value);
    setSelectedTags(newTags);
    returnFieldValue?.(newTags);
  };

  const handleKeyDown = (e) => {
    if(disabled) return
    if (
      e.key === 'Enter' ||
      e.key === ',' ||
      e.key === 'Tab'
    ) {
      e.preventDefault();
      const trimmed = query.trim();
      if (trimmed) {
        const existingTag = tags.find(
          (t) => t.label.toLowerCase() === trimmed.toLowerCase()
        );
        if (existingTag) {
          addTag(existingTag);
        } else {
          addTag({ label: trimmed, value: trimmed });
        }
      }
    } else if (e.key === 'Backspace' && !query && selectedTags.length) {
      removeTag(selectedTags[selectedTags.length - 1].value);
    }
  };

  // const createTag = async () =>  {
  //   try {
  //     const payload = {
  //       name: query
  //     }

  //     if(createFunction) {
  //       createFunction(payload)
  //     }
      
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  return (
    <div className="w-full relative" ref={wrapperRef}>
      {inputLabel && (
        <label className="block mb-2 text-sm font-medium text-gray-700">
          {inputLabel}
        </label>
      )}

      <div
        className={`rounded py-2 px-2 text-sm w-full focus:border-gray-800 focus:outline-none hover:border-gray-200 hover:bg-gray-50 border bg-gray-100 transition duration-200 focus:bg-white font-outfit placeholder:font-outfit flex items-center relative flex-wrap gap-2   ${hasError ? 'border-red-600' : 'border-gray-100'}`} 
        // className={`flex items-center relative flex-wrap gap-2 rounded-md px-3 py-2 text-sm leading-[21px] w-full focus:border-[#9CA3AF] focus:outline-none hover:border-gray-200 hover:bg-gray-50 border bg-white transition duration-200 shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] focus:ring-2 focus-within:ring-[#11182714] focus-within::bg-white ${hasError ? 'border-red-600' : 'border-[#D1D5DB]'}`}  
      >
        {selectedTags.map((tag) => (
          <span
            key={tag.value}
            className="flex items-center bg-white text-gray-700 px-2 py-1 rounded-md text-sm"
          >
            {tag.label}
            <button
              type="button"
              onClick={() => removeTag(tag.value)}
              className="ml-1 text-gray-500"
            >
              <CloseIcon className={`w-4 h-4`} />
            </button>
          </span>
        ))}

        <input
          ref={inputRef}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setOptionsOpen(true);
          }}
          disabled={disabled}
          onKeyDown={handleKeyDown}
          onFocus={() => setOptionsOpen(true)}
          placeholder={selectedTags.length === 0 ? inputPlaceholder : ''}
          className="flex-1 bg-transparent outline-none text-sm py-1 w-[150px]"
        />

        {tags?.length > 0 && <button type="button" className="p-1 absolute top-2.5 right-1">
          <ChevronUpDownIcon size={16} />
        </button>}
      </div>
      {helperText && helperText !== '' && <label className='block mt-2 text-[12px] text-[#6B7280]'>{helperText}</label>}

      {
      // tags?.length > 0 && 
      optionsOpen && filteredTags.length > 0 && (
        <div className={`absolute ${positionClasses[position]} mt-2 w-full border border-[#D1D5DB] scrollbar-hidden rounded-md bg-white shadow-lg z-50 max-h-[200px] min-w-[200px] overflow-y-scroll py-2`}>
          {filteredTags.map((tag) => (
            <button
              key={tag.value}
              type="button"
              onClick={() => addTag(tag)}
              className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              {tag.label}
            </button>
          ))}
        </div>
      )}
      {/* {showCreate && query.length > 0 && optionsOpen && filteredTags.length === 0 && (
        <div className="absolute mt-2 w-full border border-[#D1D5DB] scrollbar-hidden rounded-md bg-white shadow-lg z-50 max-h-[200px] min-w-[200px] overflow-y-scroll py-2 px-2 flex items-start justify-between gap-x-2">
          <p className='text-sm leading-[21px]'>{query}</p>
          <button onClick={() => {createTag()}} className="rounded-full cursor-pointer disabled:cursor-not-allowed bg-[#F3F4F6] text-[#374151] disabled:text-[#809099] px-4 py-1.5 font-medium text-[14px] flex items-center justify-center gap-x-1">
                            
            {!creating ? 'Create' : <SpinnerIcon size={20} color='#6B7280' className='animate-spin' /> }
          </button>
        </div>
      )} */}
    </div>
  );
};

export default TagCloud;
